import { Box } from "@mui/material";

import BaseHeader from "@/App/BaseApp/Header/BaseHeader";
import { HeaderAppLogo } from "@/App/BaseApp/Header/components/HeaderAppLogo";
import { NavToggleButton } from "@/App/BaseApp/Header/components/NavToggleButton";
import AuthorizedElement from "@/common/components/Auth/AuthorizedElement";
import { AppPermission } from "@/core/api/generated/v1";

import GlobalSearch from "./GlobalSearch/GlobalSearch";

export default function Header() {
  return (
    <BaseHeader
      withOnboarding
      mainContent={
        <>
          <AuthorizedElement permissions={[AppPermission.FleetAppAccess]}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                py: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  zIndex: 2,
                  mr: { xxs: 0, md: 3, lg: 6 },
                }}
              >
                {/* Nav toggle */}
                <NavToggleButton />

                {/* App logo */}
                <HeaderAppLogo />
              </Box>

              <GlobalSearch />
            </Box>
          </AuthorizedElement>
        </>
      }
    />
  );
}
